import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import GenericFilter from '../GenericFilter';
import { DeviceType, DeviceTypeDisplayText } from '../../types';
const DeviceTypeFilter = ({ setFilter, selectedDeviceTypes, disabled, hideSuperhubDevices = false, }) => {
    const filteredDeviceTypes = Object.keys(DeviceType)
        .map((key) => DeviceType[key])
        .filter((item) => item && (!hideSuperhubDevices || item !== DeviceType.EB_SUPER_HUB));
    const handleFilterChange = (types) => {
        requestAnimationFrame(() => {
            setFilter(types);
        });
    };
    return (_jsx(GenericFilter, { title: "Device Type", setFilter: handleFilterChange, items: filteredDeviceTypes, selectedItems: selectedDeviceTypes.filter((type) => !hideSuperhubDevices || type !== DeviceType.EB_SUPER_HUB), transformItemName: (value) => DeviceTypeDisplayText[value], disabled: disabled }, void 0));
};
export default React.memo(DeviceTypeFilter);
